import { render, staticRenderFns } from "./PackingSlips.vue?vue&type=template&id=aed8444a&"
import script from "./PackingSlips.vue?vue&type=script&lang=js&"
export * from "./PackingSlips.vue?vue&type=script&lang=js&"
import style0 from "./PackingSlips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports